import {
  deleteCookie,
  getCookie,
  getExpireDate,
  getUserProfile,
  setToken,
  setUserLocalStorage,
  setCookieSuscription,
  getUserJwt
} from "helpers";
import { useEffect, useState } from "react";
import { ButtonLogin, GoogleOneTap, RememberUser, UserAvatar } from "./components";
import { useAuth0 } from "@auth0/auth0-react";

const Auth0 = ({ suscriptionPrice, isShowGoolgeOneTap }) => {
  const [userAuth0, setUserAuth0] = useState(null);
  const [userSucription, setUserSucription] = useState(false);
  const [showRemember, setShowRemember] = useState(false);
  const [showGoogleOneTap, setShowGoogleOneTap] = useState(false);
  const { isLoading, user, isAuthenticated } = useAuth0();
  
  const tokenVF = async () => {
      // try{
      const token = getUserJwt();
      if(token){
        setToken(token);
      }
      // }catch(e){
      //   if(e.error){
      //     document.cookie = `invalidTokenAuth0=true; path=/`;
      //   }
      // }
  };


  const timePassed = (time) => {
    time = new Date(time);
    const MINUTES = 1 * 60 * 1000;
    if (new Date() - time > MINUTES) {
      return true;
    }
  };

  const statusSuscription = async () => {
    const token = getUserJwt();

    const api = `${process.env.NEXT_PUBLIC_AUTH0_API}/info?token=${token}&apikey=clarin`;
    
    await fetch(api, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.json())
    .then((data) => {
      if(data.error){
        // document.cookie = `invalidTokenAuth0=true; path=/`;
        console.log("Error retrieving JWT from API");
        return false;
      }

      let jwt = data.jwt != null ? data.jwt : "";
      setToken(jwt);
      if (document.getElementById("wb_meter")) {
        document.getElementById("wb_meter").setAttribute("jwt", jwt);
      }
      let susStatus = data.user != null
        ? data?.user?.data?.subscriptions.map((sus) => {
            return sus.pId;
          })
        : "";
      let suscription = susStatus?.includes("CLARIN_C") || susStatus?.includes("CLARIN_D") || susStatus?.includes("CLA_OLE") ? "1" : '0';
      setCookieSuscription(suscription);
      setUserSucription(suscription == "1" ? true : false);
      
      if (suscription == "1") {
        deleteCookie("susTemp");
      } 
      if (getCookie("susTemp") == "true") {
        setUserSucription(true);
        setCookieSuscription(1);
      }
      setUserLocalStorage(user, data);
    })
    .catch((error) => {
      console.log(error);
    });
    
  }

  const statusSuscriptionId = async () => {
    const user = getUserProfile();
    console.log("Status",user.id)
    const api = `${process.env.NEXT_PUBLIC_AUTH0_API}/status/${user.id}`;
    await fetch(api, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.json())
    .then((data) => {
      let suscription = data?.statusId ? data?.statusId : "0";
      setCookieSuscription(suscription);
      setUserSucription(suscription == "1" ? true : false);
      
      if (suscription == "1") {
        deleteCookie("susTemp");
      } 
      
    })
    .catch((error) => {
      console.log(error);
    });
  };

  const handleUserProfile = async (userProfile) => {
    console.log("isAuthenticated",isAuthenticated)
    setUserAuth0(userProfile);
    if (document.getElementById("wb_meter")) {
      document
        .getElementById("wb_meter")
        .setAttribute("jwt", userProfile?.jwt);
    }
    
    const suscRT = getCookie("suscRT");
    if ( getCookie("suscRT") != "" && userProfile.subscriptionStatus != "subscribed") {
      if (timePassed(suscRT)) {
        deleteCookie("suscRT");
        await Promise.all([statusSuscriptionId(), statusSuscription()]);
      } else {
        setUserSucription(true);
        setCookieSuscription(1);
      }
    }
    
    if (getCookie("statusSus") === "") {
      console.log("NO COOKIE")
      if(window.localStorage.getItem("zonda.clarin.jwt") ){
        window.localStorage.removeItem("zonda.clarin.jwt");
        window.localStorage.removeItem("zonda.clarin.identity");
        window.localStorage.removeItem("zonda.clarin.zssid");
      }
      await Promise.all([statusSuscriptionId(), statusSuscription()]);
    }

    if (getCookie("__token_auth0") === "") {
      tokenVF();
    }

    if(getCookie("susTemp") === "true") {
      setUserSucription(true);
      setCookieSuscription(1);
    }

    if (getCookie("statusSus") == 1) {
      setUserSucription(true);
    }

    setShowRemember(true);
  }
  
  useEffect(() => {
      deleteCookie("auth0_redir");
      const userProfile = getUserProfile();
      if (userProfile === null) {
        setUserSucription(false);
        isShowGoolgeOneTap && setShowGoogleOneTap(true);
        setShowRemember(true);
        return;
      }
      handleUserProfile(userProfile);
  }, []);

  return (
    <>
      {/* {showRemember && <RememberUser userSucription={userSucription} userAuth0={userAuth0}/>} */}
      {userAuth0 ? (
        <UserAvatar
          suscriptionPrice={suscriptionPrice}
          userAuth0={userAuth0}
          userSucription={userSucription}
        />
      ) : (
        <>
          {showGoogleOneTap && <GoogleOneTap />}
          <ButtonLogin suscriptionPrice={suscriptionPrice} />
        </>
      )}
    </>
  );
};

export default Auth0;
